import { createClient } from "@supabase/supabase-js";

const supabaseUrl = "https://laqarceimatbjauaoxrc.supabase.co";
const supabaseAnonKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxhcWFyY2VpbWF0YmphdWFveHJjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDM2MjA5MTcsImV4cCI6MjA1OTE5NjkxN30.IzbLlSo6h0dwaolXI7CBo0y31npRilK5s2r_NuIxdG0";

// Initialize client for dev schema
export const supabaseDev = createClient(supabaseUrl, supabaseAnonKey, {});
